import React from 'react';

export const DrawerBody = ({ children }: { children: React.ReactNode }) => (
  <>
    <div className="drawer-body">{children}</div>
    <style jsx>
      {`
        .drawer-body {
          flex: 1;
          overflow: auto;
          padding: 24px 24px 0px 24px;
        }
      `}
    </style>
  </>
);
